import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { RouterOutputs } from "@/trpc";

export type ActiveOrganizationWageSet =
  RouterOutputs["organizationWageSet"]["listForNewOffer"][number];

/**
 * Wage sets a new offer or template can use, each with the wages an offer
 * created now would keep. The server pins from this same list.
 */
export function useActiveOrganizationWageSets(
  organizationBusinessUnitId: string,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.organizationWageSet.listForNewOffer.queryOptions({
      organizationBusinessUnitId,
    }),
  );
}
